module.exports = __webpack_public_path__ + "static/media/pain-management-icon@3x.0138dffa.png";